import { Arrangement, ClusterWithArrangements } from '@thiememeulenhoff/types';

export function mapClustersWithArrangementsByMethodSlug(
  arrangements: Array<Arrangement>,
  methodSlug: string,
): Array<ClusterWithArrangements> {
  const methodArrangements = arrangements.filter(
    (arrangement) => arrangement.methodObject.slug === methodSlug,
  );
  const firstArrangement = methodArrangements.at(0);

  if (!firstArrangement) {
    return [];
  }

  return [
    {
      code: `management-${methodSlug}`,
      name: firstArrangement.methodObject.name,
      methodName: firstArrangement.methodObject.name,
      methodSlug,
      arrangementCodes: methodArrangements.map(
        (arrangement) => arrangement.code,
      ),
      arrangements: methodArrangements,
    },
  ];
}
